import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "run-board" }
const _hoisted_2 = {
  key: 0,
  class: "leaderboard-table"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { colspan: "999" }
const _hoisted_6 = ["width"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "run-info" }
const _hoisted_11 = { class: "ranks" }
const _hoisted_12 = {
  key: 1,
  class: "rank"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["href"]
const _hoisted_15 = {
  key: 1,
  class: "timecode"
}
const _hoisted_16 = ["href", "title"]
const _hoisted_17 = {
  key: 3,
  class: "dropdown is-right"
}
const _hoisted_18 = {
  class: "dropdown-trigger",
  tabindex: "0"
}
const _hoisted_19 = {
  class: "dropdown-menu",
  role: "menu"
}
const _hoisted_20 = { class: "dropdown-content" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  key: 0,
  class: "run-filters"
}
const _hoisted_24 = ["colspan"]
const _hoisted_25 = {
  key: 0,
  class: "filter-value"
}
const _hoisted_26 = {
  key: 1,
  class: "run-cards"
}
const _hoisted_27 = { class: "run-info" }
const _hoisted_28 = ["width"]
const _hoisted_29 = {
  key: 1,
  class: "run-card"
}
const _hoisted_30 = {
  key: 0,
  class: "run-card"
}
const _hoisted_31 = { class: "run-info" }
const _hoisted_32 = { class: "headline" }
const _hoisted_33 = { class: "ranks" }
const _hoisted_34 = {
  key: 1,
  class: "rank"
}
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { class: "time-info" }
const _hoisted_37 = ["href"]
const _hoisted_38 = {
  key: 1,
  class: "timecode"
}
const _hoisted_39 = ["href", "title"]
const _hoisted_40 = {
  key: 3,
  class: "dropdown is-right"
}
const _hoisted_41 = {
  class: "dropdown-trigger",
  tabindex: "0"
}
const _hoisted_42 = {
  class: "dropdown-menu",
  role: "menu"
}
const _hoisted_43 = { class: "dropdown-content" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { class: "timestamp subtitle is-6" }
const _hoisted_46 = { class: "run-info" }
const _hoisted_47 = {
  key: 0,
  class: "filter-value"
}

import TimeService from "@/services/TimeService";
import { LeaderboardEntry, Run, SavedFilmsService } from "@/api";
import { ContentLoader } from "vue-content-loader";
import { onMounted, ref, watch } from "vue";
import FocusToggle from '@/directives/FocusToggle';



export default /*@__PURE__*/_defineComponent({
  __name: 'RunBoard',
  props: {
    runs: { default: () => [] },
    filters: { default: () => { return {} } }
  },
  setup(__props: any) {


const props = __props;

const vFocusToggle = FocusToggle;

const filteredEntries = ref([] as LeaderboardEntry[]);
const hasPlatformFilter = ref(true);
const extraFilters = ref({} as Record<string, string | null>);

function getHostname(url: string) {
  var rawHostname = new URL(url).hostname;
  return rawHostname.split(".").slice(-2).join(".");
}

onMounted(() => {
    updateFilters();
});

watch(() => props.runs, (r) => {
  refresh();
}, { deep: true })

watch(() => props.filters, f => {
  updateFilters();
})

async function refresh() {
    applyFilters();
}

function updateFilters() {
    refresh();
    if(props.filters) {
      // Special casing Platform filter for table layout
      hasPlatformFilter.value = props.filters.hasOwnProperty("Platform");
      extraFilters.value = Object.assign({}, props.filters);
      delete extraFilters.value["Platform"];
    }
  }

function applyFilters() {
    if(props.runs == null) return;

    let entries = props.runs;

    for(let filter of Object.keys(props.filters)) {
        if(props.filters[filter] != null) {
            entries = entries.filter(f => f.FilterValues == null || f.FilterValues[filter] == props.filters[filter]);
        }
    }

    filteredEntries.value = entries;
}

function formatDate(date: string): string {
    return TimeService.iso8601ToShortFormat(date);
}

async function downloadFilm(filmId: string, filename: string) {
  try {
    const resp = await SavedFilmsService.downloadSavedFilm(filmId);

    let blob = await resp.blob();

    var url = window.URL.createObjectURL(blob);
    const anchorElement = document.createElement('a');
    anchorElement.href = url;
    anchorElement.download = filename;
    anchorElement.target = "_blank";

    anchorElement.click();
    anchorElement.remove();
  } catch {
    console.error("Failed to download saved film");
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.$store.state.isMobileSmall)
      ? (_openBlock(), _createElementBlock("table", _hoisted_2, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _cache[0] || (_cache[0] = _createElementVNode("th", { class: "ranks" }, "Rank", -1)),
              _cache[1] || (_cache[1] = _createElementVNode("th", null, "Runner", -1)),
              _cache[2] || (_cache[2] = _createElementVNode("th", null, "Time", -1)),
              _cache[3] || (_cache[3] = _createElementVNode("th", null, "Date", -1)),
              _cache[4] || (_cache[4] = _createElementVNode("th", null, "Points", -1)),
              (hasPlatformFilter.value)
                ? (_openBlock(), _createElementBlock("th", _hoisted_3, "Platform"))
                : _createCommentVNode("", true)
            ])
          ]),
          (!_ctx.runs)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_4, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (i) => {
                  return _createElementVNode("tr", { key: i }, [
                    _createElementVNode("td", _hoisted_5, [
                      _createVNode(_unref(ContentLoader), {
                        width: "170",
                        height: "18",
                        "primary-color": "#1f2a3c",
                        "secondary-color": "#2c3b55"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("rect", {
                            x: "0",
                            y: "5",
                            rx: "2",
                            ry: "2",
                            width: (150 + Math.random() * 20),
                            height: "10"
                          }, null, 8, _hoisted_6)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                }), 64))
              ]))
            : (_ctx.runs.length == 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_7, _cache[5] || (_cache[5] = [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", { colspan: "999" }, " No runs to show yet! ")
                  ], -1)
                ])))
              : (filteredEntries.value)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
                    (filteredEntries.value.length == 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_9, _cache[6] || (_cache[6] = [
                          _createElementVNode("td", { colspan: "999" }, " No runs match the specified filter(s) ", -1)
                        ])))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredEntries.value, (entry) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: entry.RunId
                      }, [
                        _createElementVNode("tr", _hoisted_10, [
                          _createElementVNode("td", _hoisted_11, [
                            (entry.Rank! <= 3)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: _normalizeClass(["trophy", 'rank-' + entry.Rank])
                                }, null, 2))
                              : _createCommentVNode("", true),
                            (entry.Rank! > 3)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(entry.Rank), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entry.Participants, (p, i) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: p.UserId
                              }, [
                                _createVNode(_component_router_link, {
                                  to: '/profiles/' + p.Username
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(p.Username), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"]),
                                (entry.Participants && entry.Participants.length > 0 && i < entry.Participants.length-1)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, ", "))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ]),
                          _createElementVNode("td", null, [
                            (entry.Participants && entry.Participants[0].EvidenceLink)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  target: "_blank",
                                  rel: "noopener noreferrer",
                                  href: entry.Participants[0].EvidenceLink,
                                  class: "timecode"
                                }, _toDisplayString(_ctx.$filters.durationDisplay(entry.Duration)), 9, _hoisted_14))
                              : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.$filters.durationDisplay(entry.Duration)), 1)),
                            (entry.Participants && entry.Participants.length > 1)
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(entry.Participants.slice(1), (partner) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, {
                                    key: partner.Username
                                  }, [
                                    (partner.EvidenceLink)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 0,
                                          target: "_blank",
                                          rel: "noopener noreferrer",
                                          href: partner.EvidenceLink,
                                          title: partner.Username,
                                          class: "partner-evidence"
                                        }, _cache[7] || (_cache[7] = [
                                          _createElementVNode("i", { class: "fas fa-video" }, null, -1)
                                        ]), 8, _hoisted_16))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                }), 128))
                              : _createCommentVNode("", true),
                            ((entry.SavedFilms?.length ?? 0) > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                  _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_18, _cache[8] || (_cache[8] = [
                                    _createElementVNode("button", {
                                      class: "button dropdown-button",
                                      "aria-haspopup": "true",
                                      "aria-controls": "dropdown-menu",
                                      "tab-index": "-1"
                                    }, [
                                      _createElementVNode("span", { class: "icon is-small" }, [
                                        _createElementVNode("i", {
                                          class: "fas fa-caret-down",
                                          "aria-hidden": "true"
                                        })
                                      ])
                                    ], -1)
                                  ]))), [
                                    [_unref(vFocusToggle), 'is-active', "parent"]
                                  ]),
                                  _createElementVNode("div", _hoisted_19, [
                                    _createElementVNode("div", _hoisted_20, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entry.SavedFilms, (film) => {
                                        return (_openBlock(), _createElementBlock("button", {
                                          class: "button ghost is-primary",
                                          onClick: () => downloadFilm(film.id!, film.filename!)
                                        }, " Download " + _toDisplayString(film.filename), 9, _hoisted_21))
                                      }), 256))
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, _toDisplayString(formatDate(entry.OccurredAt!)), 1),
                          _createElementVNode("td", null, _toDisplayString(entry.Points), 1),
                          (hasPlatformFilter.value)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_22, _toDisplayString(entry.FilterValues!["Platform"]), 1))
                            : _createCommentVNode("", true)
                        ]),
                        (extraFilters.value)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_23, [
                              _createElementVNode("td", {
                                colspan: hasPlatformFilter.value ? 6 : 5
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(extraFilters.value, (filterValue, filter) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, { key: filter }, [
                                    (entry.FilterValues![filter])
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(filter) + ": " + _toDisplayString(entry.FilterValues![filter]), 1))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                }), 128))
                              ], 8, _hoisted_24)
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_26, [
          (!_ctx.runs)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(10, (i) => {
                return _createElementVNode("div", {
                  class: "run-card",
                  key: i
                }, [
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_unref(ContentLoader), {
                      class: "headline",
                      width: "170",
                      height: "18",
                      "primary-color": "#1f2a3c",
                      "secondary-color": "#2c3b55"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("rect", {
                          x: "0",
                          y: "5",
                          rx: "2",
                          ry: "2",
                          width: (150 + Math.random() * 20),
                          height: "10"
                        }, null, 8, _hoisted_28)
                      ]),
                      _: 1
                    })
                  ])
                ])
              }), 64))
            : (_ctx.runs.length == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, _cache[9] || (_cache[9] = [
                  _createElementVNode("div", { class: "run-info" }, [
                    _createElementVNode("div", { class: "headline" }, " No runs to show yet! ")
                  ], -1)
                ])))
              : (filteredEntries.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    (filteredEntries.value.length == 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, _cache[10] || (_cache[10] = [
                          _createElementVNode("div", { class: "run-info" }, [
                            _createElementVNode("div", { class: "headline" }, " No runs match the specified filter(s) ")
                          ], -1)
                        ])))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredEntries.value, (entry) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "run-card",
                        key: entry.RunId
                      }, [
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("div", _hoisted_33, [
                              (entry.Rank! <= 3)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: _normalizeClass(["trophy", 'rank-' + entry.Rank])
                                  }, null, 2))
                                : _createCommentVNode("", true),
                              (entry.Rank! > 3)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(entry.Rank), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entry.Participants, (p, j) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: p.Username
                                }, [
                                  _createVNode(_component_router_link, {
                                    to: '/profiles/' + p.Username
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(p.Username), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]),
                                  (j != (entry.Participants!.length - 1))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_35, ", "))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128)),
                              _createElementVNode("div", null, [
                                _createTextVNode(_toDisplayString(entry.Points) + " ", 1),
                                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "subtitle is-6" }, "points", -1))
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_36, [
                            (entry.Participants && entry.Participants[0].EvidenceLink)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  href: entry.Participants[0].EvidenceLink,
                                  target: "_blank",
                                  rel: "noopener noreferrer",
                                  class: "timecode"
                                }, _toDisplayString(_ctx.$filters.durationDisplay(entry.Duration)), 9, _hoisted_37))
                              : (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_ctx.$filters.durationDisplay(entry.Duration)), 1)),
                            (entry.Participants && entry.Participants.length > 1)
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(entry.Participants.slice(1), (partner) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, {
                                    key: partner.Username
                                  }, [
                                    (partner.EvidenceLink)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 0,
                                          href: partner.EvidenceLink,
                                          title: partner.Username,
                                          target: "_blank",
                                          rel: "noopener noreferrer",
                                          class: "partner-evidence"
                                        }, _cache[12] || (_cache[12] = [
                                          _createElementVNode("i", { class: "fas fa-video" }, null, -1)
                                        ]), 8, _hoisted_39))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                }), 128))
                              : _createCommentVNode("", true),
                            ((entry.SavedFilms?.length ?? 0) > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                  _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_41, _cache[13] || (_cache[13] = [
                                    _createElementVNode("button", {
                                      class: "button dropdown-button",
                                      "aria-haspopup": "true",
                                      "aria-controls": "dropdown-menu",
                                      "tab-index": "-1"
                                    }, [
                                      _createElementVNode("span", { class: "icon is-small" }, [
                                        _createElementVNode("i", {
                                          class: "fas fa-caret-down",
                                          "aria-hidden": "true"
                                        })
                                      ])
                                    ], -1)
                                  ]))), [
                                    [_unref(vFocusToggle), 'is-active', "parent"]
                                  ]),
                                  _createElementVNode("div", _hoisted_42, [
                                    _createElementVNode("div", _hoisted_43, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entry.SavedFilms, (film) => {
                                        return (_openBlock(), _createElementBlock("button", {
                                          class: "button ghost is-primary",
                                          onClick: () => downloadFilm(film.id!, film.filename!)
                                        }, " Download " + _toDisplayString(film.filename), 9, _hoisted_44))
                                      }), 256))
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_45, _toDisplayString(formatDate(entry.OccurredAt!)), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("div", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters, (filterValue, filter) => {
                              return (_openBlock(), _createElementBlock(_Fragment, { key: filter }, [
                                (entry.FilterValues![filter])
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(filter) + ": " + _toDisplayString(entry.FilterValues![filter]), 1))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 128))
                          ])
                        ])
                      ]))
                    }), 128))
                  ], 64))
                : _createCommentVNode("", true)
        ]))
  ]))
}
}

})